/**
 * A prop-less wrapper that renders `./WhatOurCustomersRefactor.tsx` with the brand's default copy.
 * Its one importer is `components/Contentful/SubProduct.tsx` (the Contentful product sub-category
 * pages); every other caller imports `./WhatOurCustomersRefactor.tsx` or
 * `./WhatOurCustomersCustom.tsx`.
 */
import React from "react";
import WhatOurCustomersSayRefactor from "./WhatOurCustomersRefactor";

/** The testimonial carousel with default copy and no override. */
const WhatOurCustomers: React.FC = () => {
	return <WhatOurCustomersSayRefactor />;
};

export default WhatOurCustomers;
